export default {
  //  接口地址    //http://demo.gzw.xin/sealsite/1000    http://seal.dev.zhian.xin/seal/1000    http://demo.gzw.xin/seal/4100    http://demo.gzw.xin/seal/1000   //http://hzyzw.com/sealsite/3301   http://hnseal.cn/sealsite/4100     http://zhian.xin/seal/1000     http://gzw.xin/sealsite/1000
  baseUrl: society_api.getAttribute('data-url'),

  //  图片地址
  photoUrl: document.getElementById('society_api').getAttribute('data-img-url'),


  common: {

    // LIB-THIRD-第三方平台转接

    libThird: {
      //  发送短信验证码
      smsSend: '/api/v1/lib/third/sms/send',
      
      //发送短信验证码-需校验验证码
      smsSendKaptcha: '/api/v1/lib/third/sms/send/kaptcha',

      //  wxRedirctState
      clientWxRedirect: '/api/v1/client/wx/redirect',

      //  根据参数生成微信重定向URL的链接
      libThirdWxRedirectUrl: '/api/v1/lib/third/wxRedirectUrl',

      // 上传图片，返回图片相对路径（在OSS中的路径）
      oss: '/api/v1/lib/third/oss',

      // 人脸识别-通过两个URL(OSS上的图片也通过这种方式)
      faceVerifyBase64: '/api/v1/lib/third/face/verify/base64',

      // 人脸识别-通过两个URL(OSS上的图片也通过这种方式)
      faceVerifyUrl: '/api/v1/lib/third/face/verify/url',

      // 图片OCR识别, 不保存到OSS上
      ocr: '/api/v1/lib/third/ocr'
    },

    libSass: {

      // 获取词典文件
      saasDict: '/api/v1/saas/dict/:file',

      // 获取SaaS中租客的配置信息
      saasTenantConfig: '/api/v1/saas/tenant/config',

      // 获取前端配置文件-指定记录
      siteSetUpFront: '/api/v1/saas/site/setup/front',

      //获取前端配置文件-全部作为一个json
      siteSetUpFrontAll: '/api/v1/saas/site/setup/front/all'

    },

    libUtil: {

      // 防暴力破解-图片生成
      kaptcha: '/api/v1/lib/util/kaptcha/'

    }


  },

  sys: {

    // SYS-通用接口
    sys: {

      // 部门/单位-列出
      queryBranch: '/api/v1/sys/query/branch',
      //获取SaasSiteSetupFront配置信息列表
      getSaasSiteSetupFront: '/api.sys/v1/sys/saas/site/setup/front',
      //设置SaasSiteSetupFront配置信息
      setSaasSiteSetupFront: '/api.sys/v1/sys/saas/site/setup/front/:id',
      //获取SaaS中租客的配置信息
      saasTenantConfig: '/api.sys/v1/sys/saas/tenant/config'
    },

    // SYS-用户-本人操作

    sysUserMine: {

      // 修改用户自己的密码
      opChangePass: '/api.sys/v1/sys/user/mine/op/changePass',

      // 获取用户自己的详情  修改用户自己的信息
      opData: '/api.sys/v1/sys/user/mine/op/data',

      // 系统用户注销
      opLogout: '/api.sys/v1/sys/user/mine/op/logout',

      // 用户登录-使用密码
      opLoginPass: '/api/v1/sys/user/mine/op/login/pass',

      // 用户登录-手机号+验证码
      opLoginSms: '/api/v1/sys/user/mine/op/login/sms',

    },

    sysAdmin: {

      // 部门/单位-列出
      branch: '/api.sys/v1/sys/admin/branch/:id',

      // 角色-列出
      role: '/api.sys/v1/sys/admin/role/:id',

      // 系统账号-列出
      user: '/api.sys/v1/sys/admin/user/:id',

      // 系统账号-管理员重设密码
      opUserChangePass: '/api.sys/v1/sys/admin/op/user/changePass/:id',

      // 系统账号/人员账号-修改所属部门
      userBranch: '/api.sys/v1/sys/admin/user/branch/:id',

      // 系统账号/人员账号-修改权限和角色
      userRights: '/api.sys/v1/sys/admin/user/rights/:id',

      // 获取操作日志
      userLog: '/api.sys/v1/sys/admin/user/log'


    },

    // SYS-CLIENT-门店的管理
    sysClientCompany: {

      // 特行企业-列表
      company: '/api.sys/v1/sys/client/company/:id',

      // 特行企业-管辖范围内所有企业变更记录-列表
      alteration: '/api.sys/v1/sys/client/company/alteration/:id',

      // 特行企业-注册信息变更（备案后变更会记录日志）
      opAlter: '/api.sys/v1/sys/client/company/op/alter/:id',

      // 特行企业-备案提交审核
      opSubmit: '/api.sys/v1/sys/client/company/op/submit/:id',

      // 特行企业-更改企业老板（所有者）
      opAdmin: '/api.sys/v1/sys/client/company/op/admin/:id',

      // 特行企业-备案核准操作
      opAudit: '/api.sys/v1/sys/client/company/op/audit/:id',

      // 特行企业-扩展信息修改
      opExt: '/api.sys/v1/sys/client/company/op/ext/:id'
    },

    //  SYS-CLIENT-普通用户管理（非从业人员）
    sysClientUser: {

      // 个人用户-列表
      user: '/api.sys/v1/sys/client/user/:id',

      // 个人用户-根据手机号检测用户是否存在
      check: '/api.sys/v1/sys/client/user/check',

      // 个人用户-详情（根据手机号）
      queryDetail: '/api.sys/v1/sys/client/user/query/detail',

      // 个人用户-修改密码
      opChangePass: '/api.sys/v1/sys/client/user/op/changePass/:id'


    },

    // SYS-SOCIETY-基础功能
    sysClientSociety: {

      // 民警巡检（admin）-列表
      adminInspect: '/api.sys/v1/society/admin/inspect/:id',

      // 案件-企业案件列表
      companyCase: '/api.sys/v1/society/company/case/:id',

      // 处罚企业-处罚信息列表查询
      companyPunishment: '/api.sys/v1/society/company/punishment/:id',

      // 民警巡检-巡检
      inspect: '/api.sys/v1/society/inspect/:id',

      // 可疑信息上报-列表查看
      suspicious: '/api.sys/v1/society/suspicious/:id',

      // 可疑信息上报-处置
      suspiciousOpDispose: '/api.sys/v1/society/suspicious/op/dispose/:id',

      // 处罚个人-处罚信息列表查询
      userPunishment: '/api.sys/v1/society/user/punishment/:id',


    },

    // SYS-CLIENT-从业人员管理
    sysClientUserStaff: {

      // 从业人员-列表
      staff: '/api.sys/v1/sys/client/user/staff/:id',

      // 从业人员-获取变更记录
      alterLog: '/api.sys/v1/sys/client/user/staff/alter/log/:id',

      // 从业人员-实名信息变更
      opAlter: '/api.sys/v1/sys/client/user/staff/op/alter/:id',

      // 从业人员-审核备案
      opAudit: '/api.sys/v1/sys/client/user/staff/op/audit/:id',

      // 从业人员-提交备案
      opSubmit: '/api.sys/v1/sys/client/user/staff/op/submit/:id',

      // 从业人员-加入、修改和退出企业
      opChangeCompany: '/api.sys/v1/sys/client/user/staff/op/changeCompany/:id'

    },

    // 信息管理-后台接口
    sysInfo: {

      // 意见项目-列表
      advice: '/api.sys/v1/info/advice/:id',

      // 意见记录列表
      adviceSubmit: '/api.sys/v1/info/advice/submit/:id',

      // 通知-通知列表
      societyNotice: '/api.sys/v1/society/notice/:id',

      // 通知-撤回通知
      societyNoticeOpBackout: '/api.sys/v1/society/notice/op/backout/:id',

      // 通知-撤回通知
      societyNoticeOpPublish: '/api.sys/v1/society/notice/op/publish/:id',

      // 通知-撤回通知
      societyNoticeOpSent: '/api.sys/v1/society/notice/op/sent/:id',

      // 通知信息发送记录-发送记录列表
      societyNoticeSent: '/api.sys/v1/society/notice/sent/:id',

      // 通知-通知列表
      societyNoticeSentPersonal: '/api.sys/v1/society/notice/sent/personal/:id',

      // 通知-通知反馈
      societyNoticeSentPersonalOpFeedback: '/api.sys/v1/society/notice/sent/personal/op/feedback/:id',

      // 获取文章列表
      article: '/api.sys/v1/sys/info/article/:id'

    },

    // GZW-后台
    sysGzw: {

      // 工商推送信息-列表
      aic: '/api.sys/v1/gzw/sys/aic',

      // 刻章店章材-列表
      material: '/api.sys/v1/sys/gzw/material/:id',

      // 公章网订单-列表-当前订单（已付款、已受理、已制作，不含填报中）
      orderActive: '/api.sys/v1/sys/gzw/order/active',

      // 公章网订单-列表-历史订单（已交付、已取消
      orderHistory: '/api.sys/v1/sys/gzw/order/history',

      // 公章网订单-详情
      order: '/api.sys/v1/sys/gzw/order/:id',

      // 公章网订单-退款
      orderRefund: '/api.sys/v1/sys/gzw/order/refund/:id',

      // 公章网订单-列表-未付款订单（填报中)
      orderUnpaid: '/api.sys/v1/sys/gzw/order/unpaid',

      // 印章治安信息-列表
      societySealContent: '/api.sys/v1/sys/gzw/society/seal/content/:id',

      // 单位治安信息-列表
      societySealOrg: '/api.sys/v1/sys/gzw/society/seal/org/:code',

      // 印章治安信息-根据USCC查询
      societySealContentUscc: '/api.sys/v1/sys/gzw/society/seal/content/uscc/:uscc',

      // 印章治安信息-详情-XML
      societySealContentXml: '/api.sys/v1/sys/gzw/society/seal/content/xml/:id',

      // 章模图片处理-上传
      opSealCv3: '/api/v1/sys/gzw/op/seal/cv3',

      // 章模图片处理-获取
      opSealCv3ByMd5: '/api/v1/sys/gzw/op/seal/cv3/',

      // 山东一窗通数据办结
      updateSdAicState: '/api.sys/v1/gzw/sys/update/sd_aic_state/:id',

    },

    //GZW-后台-电子公章
    sysGzwDz: {
      //电子公章-详情
      seal: '/api.sys/v1/gzw/dz/seal/:id',
      //电子公章-当前订单列表
      sealActive: '/api.sys/v1/gzw/dz/seal/active',
      //电子公章-用章单位待受理订单列表
      sealCenter: '/api.sys/v1/gzw/dz/seal/center',
      //电子公章-历史订单列表
      sealHistory: '/api.sys/v1/gzw/dz/seal/history',
      //电子公章-受理
      opAccept: '/api.sys/v1/gzw/dz/op/accept/:id',
      //电子公章-交付
      opDeliver: '/api.sys/v1/gzw/dz/op/deliver/:id',
      //电子公章-制作
      opMade: '/api.sys/v1/gzw/dz/op/made/:id',
      //电子公章-取消
      opCancel: '/api.sys/v1/gzw/dz/op/cancel/:id',
      //电子公章-取消制作
      opMadeCancel: '/api.sys/v1/gzw/dz/op/made_cancel/:id',
      //电子公章-退款
      opRefund: '/api.sys/v1/gzw/dz/op/refund/:id',
      //电子公章-根据印章编码查询印章信息
      querySealContent: '/api.sys/v1/gzw/dz/query/seal/content/:code',
      //电子公章-根据使用单位编码查询使用单位信息
      querySealOrg: '/api.sys/v1/gzw/dz/query/seal/org/:code',
      //电子公章-显示图片
      sealImg: '/api.sys/v1/gzw/dz/seal/img/',
      //电子公章-获取制作三所电子公章的json数据
      querySealJson3rd: '/api.sys/v1/gzw/dz/query/seal/json/3rd/:id',
      //电子公章-章模图片获取
      sealImgDown: '/api.sys/v1/gzw/dz/seal/img_down/'
    },

    // GZW-后台统计
    sysGzwStat: {

      // 按企业统计财务数据
      financeCompany: '/api.sys/v1/sys/gzw/stat/finance/company'

    },

    // ctrl-api-sys-society-hotel : SYS-SOCIETY-旅馆业
    sysSocietyHotel: {

      record: '/api.sys/v1/sys/society/hotel/record/:id',

      // 酒店预警-列表
      warn: '/api.sys/v1/sys/society/hotel/warn/:id',

      // 酒店预警触发-列表
      warnTrigger: '/api.sys/v1/sys/society/hotel/warn/trigger/:id',

      // 酒店报警触发-处置
      warnTriggerDispose: '/api.sys/v1/sys/society/hotel/op/warn/trigger/dispose',

      // 酒店报警-列表
      alert: '/api.sys/v1/sys/society/hotel/alert/:id',

      // 酒店报警触发-列表
      alertTrigger: '/api.sys/v1/sys/society/hotel/alert/trigger/:id',

      // 酒店报警触发-处置
      alertTriggerDispose: '/api.sys/v1/sys/society/hotel/op/alert/trigger/dispose'

    },

    // SYS-CLIENT-STAT
    sysClientStat: {

      // 特行企业工作统计
      reportCompany: '/api.sys/v1/sys/client/stat/report/company',

      // 治安辖区工作统计
      reportPolice: '/api.sys/v1/sys/client/stat/report/police'
    },

    // SYS-印章业务办理
    sysSocietySealBiz: {
      // 备案单-列表 / 新增
      papersRegister: '/api.sys/v1/sys/society/seal/register/:id',

      // 使用单位-根据USCC查询
      sealOrgUscc: '/api.sys/v1/sys/society/seal/org/uscc',

      // 使用单位-根据单位名称查询, 返回列表
      sealOrgName: '/api.sys/v1/sys/society/seal/org/name',

      // 备案单-提交审核
      opPapersRegisterSubmit: '/api.sys/v1/sys/society/seal/register/op/submit/:id',

      // 备案单-审核
      opPapersRegisterPermit: '/api.sys/v1/sys/society/seal/register/op/permit/:id',

      // 备案单-修改文字(备案单信息和单位信息), 本接口不会修改印章信息
      opPapersRegisterAlter: '/api.sys/v1/sys/society/seal/register/op/alter',

      // 备案单-修改印章  本接口不会修改备案单信息和单位信息
      opPapersRegisterSealAlter: '/api.sys/v1/sys/society/seal/register/op/seal/alter',

      // 备案单-复核
      opPapersRegisterReview: '/api.sys/v1/sys/society/seal/register/op/review/permit/:id',

      // 备案单-根据备案单ID, 查询审核时可选的刻章企业
      queryPapersRegisterMaker: '/api.sys/v1/sys/society/seal/register/query/maker/:id',

      // 备案单-打印
      papersRegisterPrint: '/api.sys/v1/sys/society/seal/register/print/:id'

    },

    // 系统-印章-信息查询
    sysSocietySeal: {

      // 印章信息-列表 详情
      content: '/api.sys/v1/sys/society/seal/content/:id',

      // 印章信息-显示章模图片
      contentImg: '/api.sys/v1/sys/society/seal/content/img/',

      // 使用单位-列表 详情
      org: '/api.sys/v1/sys/society/seal/org/:id',

      // 印章信息-根据uscc查询某个使用单位全部印章
      contentOrg: '/api.sys/v1/sys/society/seal/content/org/:uscc'
    },

    // SYS-SEAL-作废单管理
    sysSocietySealDiscard: {
      // 作废单列表 操作
      discard: '/api.sys/v1/sys/society/seal/discard/:id',
      // 作废单 - 审核
      permit: '/api.sys/v1/sys/society/seal/discard/permit/:id',
      // 作废单 - 打印
      print: '/api.sys/v1/sys/society/seal/discard/print/:id',
      // 作废单 - 提交审核
      submit: '/api.sys/v1/sys/society/seal/discard/submit/:id',
    },

    // SOCIETY-SEAL-统计
    sysSocietySealStat: {
      //系统后台-刻章店业务统计
      biz: '/api.sys/v1/sys/society/seal/stat/biz',
      //系统后台-刻章店当前业务概况
      bizCur: '/api.sys/v1/sys/society/seal/stat/biz/cur',
      //系统后台-治安辖区工作统计
      police: '/api.sys/v1/sys/society/seal/stat/police'
    }
  }
}
